import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function cadastroposto(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@cadastroposto/FIND_CADASTROPOSTO':
      case '@cadastroposto/UPDATE_CADASTROPOSTO':
      case '@cadastroposto/DELETE_CADASTROPOSTO':
      case '@cadastroposto/STORE_CADASTROPOSTO':
      case '@cadastroposto/CADASTROPOSTO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@cadastroposto/SUCCESS_REMOVE':
      case '@cadastroposto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@cadastroposto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.cadastroposto;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@cadastroposto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.cadastroposto;
        break;
      }

      case '@cadastroposto/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
